import { UserAccessRightsGuard } from './../role/user-role/user-access-rights.guard'
import { RolePermissionsCreateComponent } from './create/show.component'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { RolePermissionsGeneralTabComponent } from './general-tab/show.component'
import { RolePermissionsIndexComponent } from './index/index.component'
import { RolePermissionsShowComponent } from './show/show.component'
import { AccessRights } from '../role/user-role/user-role'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: RolePermissionsIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.RolePermissions_read] }
  },
  {
    path: 'create',
    component: RolePermissionsCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.RolePermissions_write] }
  },
  {
    path: ':rolePermissionsId',
    component: RolePermissionsShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.RolePermissions_read] },
    children: [
      {
        path: '',
        component: RolePermissionsGeneralTabComponent,
        pathMatch: 'full'
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RolePermissionsRoutingModule {}
